module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-vodafonecvm-04@2x.08815087.jpg";